import Avatar from '@material-ui/core/Avatar';
import { withStyles } from '@material-ui/core/styles';
import AcUnitIcon from '@material-ui/icons/AcUnit';
import BlockIcon from '@material-ui/icons/Block';
import InsertDriveFileOutlinedIcon from '@material-ui/icons/InsertDriveFileOutlined';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import PauseIcon from '@material-ui/icons/Pause';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import React, { Component } from 'react';
import { defineMessages, injectIntl } from 'react-intl';

const useStyles = (theme) => ({
  avatar: {
    width: 40,
    height: 40,
    boxShadow: `0px 6px 9px 0px ${theme.palette.gray.darker}`
  }
});

const PlayAvatar = withStyles((theme) => ({
  root: {
    width: 20,
    height: 20,
    border: `2px solid ${theme.palette.background.paper}`,
    color: theme.palette.common.white,
    backgroundColor: theme.palette.green.dark
  }
}))(Avatar);

const PauseAvatar = withStyles((theme) => ({
  root: {
    width: 20,
    height: 20,
    border: `2px solid ${theme.palette.background.paper}`,
    color: theme.palette.white.main,
    backgroundColor: theme.palette.error.dark
  }
}))(Avatar);

const StopAvatar = withStyles((theme) => ({
  root: {
    width: 20,
    height: 20,
    border: `2px solid ${theme.palette.background.paper}`,
    color: theme.palette.common.white,
    backgroundColor: theme.palette.gray.darker
  }
}))(Avatar);

const CanceledAvatar = withStyles((theme) => ({
  root: {
    width: 20,
    height: 20,
    border: `2px solid ${theme.palette.background.paper}`,
    color: theme.palette.common.white,
    backgroundColor: theme.palette.error.main
  }
}))(Avatar);

const FreezeAvatar = withStyles((theme) => ({
  root: {
    width: 20,
    height: 20,
    border: `2px solid ${theme.palette.background.paper}`,
    color: theme.palette.common.white,
    backgroundColor: theme.palette.info.main
  }
}))(Avatar);

const DraftAvatar = withStyles((theme) => ({
  root: {
    width: 20,
    height: 20,
    border: `2px solid ${theme.palette.background.paper}`,
    color: theme.palette.common.white,
    backgroundColor: theme.palette.gray.darkerLight
  }
}))(Avatar);

const messages = defineMessages({});

class JobStatusIcon extends Component {
  constructor(props) {
    super(props);
    this.state = {
      item: props.item
    };
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps.item) !== JSON.stringify(this.props.item)) {
      this.setState({
        item: this.props.item
      });
    }
  }

  render() {
    const item = this.state.item;
    const closed = item.closed;
    const date_closed = item.date_closed;
    const status = item.status;

    if (status === 'PUBLISHED') {
      if (closed === false || date_closed >= new Date()) {
        return (
          <PlayAvatar>
            <PlayArrowIcon style={{ fontSize: 14 }} />
          </PlayAvatar>
        );
      } else {
        return (
          <PauseAvatar>
            <PauseIcon style={{ fontSize: 14 }} />
          </PauseAvatar>
        );
      }
    }

    if (status === 'DRAFT') {
      return (
        <DraftAvatar>
          <InsertDriveFileOutlinedIcon style={{ fontSize: 14 }} />
        </DraftAvatar>
      );
    }

    if (status === 'FREEZING') {
      return (
        <FreezeAvatar>
          <AcUnitIcon style={{ fontSize: 14 }} />
        </FreezeAvatar>
      );
    }

    if (status === 'COMPLETED') {
      return (
        <StopAvatar>
          <LockOutlinedIcon style={{ fontSize: 14 }} />
        </StopAvatar>
      );
    }

    if (status === 'CANCELED') {
      return (
        <CanceledAvatar>
          <BlockIcon style={{ fontSize: 14 }} />
        </CanceledAvatar>
      );
    }

    return null;
  }
}

export default injectIntl(withStyles(useStyles)(JobStatusIcon));
